import { IWhiteboardStateChange, IWhiteboardStateChangeNotifier } from "@gtmhub/whiteboards";

export class BufferedStateChangeNotifier implements IWhiteboardStateChangeNotifier {
  private localUnsyncedStateChanges: IWhiteboardStateChange[][] = [];

  constructor(private stateChangeNotifier: IWhiteboardStateChangeNotifier) {}

  get unsyncedStateChanges(): IWhiteboardStateChange[][] {
    return angular.copy(this.localUnsyncedStateChanges);
  }

  stateChange(changes: IWhiteboardStateChange[]): void {
    this.localUnsyncedStateChanges.push(changes);
    this.stateChangeNotifier.stateChange(changes);
  }

  shiftUnsyncedStateChange(): void {
    this.localUnsyncedStateChanges.shift();
  }

  clearUnsyncedStateChanges(): void {
    this.localUnsyncedStateChanges = [];
  }
}
